import { Typography } from '@mui/material'
import { Info } from '@mui/icons-material'

import Modal from 'components/molecules/Modal/Modal'
import { LoadingButton } from 'components/mui'

import './ImageVerificationModal.scss'

interface ImageVerificationModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  onRecapture: () => void
}

const ImageVerificationModal = ({
  open,
  onClose,
  onConfirm,
  onRecapture,
}: ImageVerificationModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="tray-image-verification-modal">
        <div className="header-box">
          <Info />

          <Typography variant="body1" textTransform="none">
            The current reference image was captured in a previous session. Does
            this image accurately reflect the current state of the tray?
          </Typography>
        </div>

        <div className="buttons-container">
          <LoadingButton
            variant="outlined"
            disabled={false}
            loading={false}
            onClick={onRecapture}
          >
            No, Recapture Image
          </LoadingButton>
          <LoadingButton
            disabled={false}
            loading={false}
            variant="contained"
            onClick={onConfirm}
          >
            Yes, Continue
          </LoadingButton>
        </div>
      </div>
    </Modal>
  )
}

export default ImageVerificationModal
